import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { getAuth, signInWithEmailAndPassword} from 'firebase/auth'
import sportsPicture from "../../images/sports.png"
import toast, { Toaster } from 'react-hot-toast'

export default function LoginPage(){
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");


    const navigate = useNavigate()

    async function logIn() {
        try{
            await signInWithEmailAndPassword(getAuth(), email, password);
            navigate("/");
        } catch(e){
            toast.error(`Email or password is incorrect: ${e.message}`);
        }
    }

    return(
        <>
        <h1>Log-In</h1>
        <Toaster  position="top-center"/>
        <div className="log-in-page">
            <div className='email'>
                <label>Email: </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}></input>
            </div>
            <div className="password">    
                <label>Password: </label>
                <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value) }></input>
            </div>    
            <button onClick={logIn}>Log In</button>
            <Link className="create-account-link" to="/createAccountPage">Don't have an account? Create one here</Link>

            <Link className="to-homepage" to="/"><img src={sportsPicture} alt="sports"/></Link>


        </div>    
        </>
    )
}